import React from 'react';

const Card = ({ children, className = '', title, hover = false, ...props }) => {
    return (
        <div
            className={`bg-white dark:bg-[#002147] rounded-lg shadow-sm border border-gray-200 dark:border-[#1a3884]/35 transition-colors duration-300 ${hover ? 'hover:shadow-md transition-shadow duration-200' : ''
                } ${className}`}
            {...props}
        >
            {title && (
                <div className="px-6 py-4 border-b border-gray-200 dark:border-[#1a3884]/35">
                    {/* Strings keep the classic heading; JSX titles render as-is so
                        pages can pass richer headers (step number + subtitle). */}
                    {typeof title === 'string'
                        ? <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>
                        : title}
                </div>
            )}
            <div className={title ? 'p-6' : 'p-6'}>{children}</div>
        </div>
    );
};

export default Card;
